module.exports = "<nav class=\"container-fluid app-header\">\r\n    <img class=\"logo\" src=\"{{logoUrl}}\" alt=\"logo\" (click)=\"onIconClick()\">\r\n    <div class=\"hidden-xs app-title\">\r\n        Pulse Dashboard\r\n    </div>\r\n    <div class=\"pull-right header-nav\" *ngIf=\"token\">\r\n        <div class=\"user-name\">{{userEmail}}&nbsp;|&nbsp;\r\n        <span class=\"logout\" (click)=\"logout()\">logout</span></div>\r\n    </div>\r\n</nav>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/header/header.component.html
// module id = 505
// module chunks = 0